unit libserviceworkers;

{$MODE ObjFPC}
{$H+}
{$modeswitch externalclass}

interface

uses
  SysUtils, JS, web;

type
  // Forward class definitions
  TJSMessagePort = class;
  TJSAbortSignal = class;
  TJSHeaders = class;
  TJSBody = class;
  TJSRequest = class;
  TJSResponse = class;
  TJSAbstractWorker = class;
  TJSWorker = class;
  TJSSharedWorker = class;
  TJSServiceWorker = class;
  TJSServiceWorkerRegistration = class;
  TJSServiceWorkerContainer = class;
  TJSNavigationPreloadManager = class;
  TJSServiceWorkerGlobalScope = class;
  TJSClient = class;
  TJSWindowClient = class;
  TJSClients = class;
  TJSExtendableEvent = class;
  TJSFetchEvent = class;
  TJSExtendableMessageEvent = class;
  TJSCache = class;
  TJSCacheStorage = class;
  TJSPostMessageOptions = class;
  TJSRequestInit = class;
  TJSResponseInit = class;
  TJSWorkerOptions = class;
  TJSRegistrationOptions = class;
  TJSNavigationPreloadState = class;
  TJSClientQueryOptions = class;
  TJSExtendableEventInit = class;
  TJSFetchEventInit = class;
  TJSExtendableMessageEventInit = class;
  TJSCacheQueryOptions = class;
  TJSMultiCacheQueryOptions = class;
  ReferrerPolicy = string;
  RequestDestination = string;
  RequestMode = string;
  RequestCredentials = string;
  RequestCache = string;
  RequestRedirect = string;
  ResponseType = string;
  WorkerType = string;
  ServiceWorkerState = string;
  ServiceWorkerUpdateViaCache = string;
  FrameType = string;
  ClientType = string;
  // Union of sequence, record
  HeadersInit = JSValue; 
  // Union of Blob, BufferSource, FormData, URLSearchParams, ReadableStream, USVstring
  BodyInit = JSValue; 
  // Union of Request, USVstring
  RequestInfo = JSValue; 
  
  { --------------------------------------------------------------------
    TJSPostMessageOptions
    --------------------------------------------------------------------}
  
  TTJSObjectDynArray = array of TJSObject;
  TJSPostMessageOptions = class(TJSObject)
    transfer : TTJSObjectDynArray;
  end;
  
  { --------------------------------------------------------------------
    TJSRequestInit
    --------------------------------------------------------------------}
  
  TJSRequestInit = class(TJSObject)
    method : string;
    headers : HeadersInit;
    body : BodyInit;
    referrer : string;
    _referrerPolicy : ReferrerPolicy;external name 'referrerPolicy';
    mode : RequestMode;
    credentials : RequestCredentials;
    cache : RequestCache;
    redirect : RequestRedirect;
    integrity : string;
    keepalive : Boolean;
    signal : TJSAbortSignal;
    window : JSValue;
  end;
  
  { --------------------------------------------------------------------
    TJSResponseInit
    --------------------------------------------------------------------}
  
  TJSResponseInit = class(TJSObject)
    status : Cardinal;
    statusText : string;
    headers : HeadersInit;
  end;
  
  { --------------------------------------------------------------------
    TJSWorkerOptions
    --------------------------------------------------------------------}
  
  TJSWorkerOptions = class(TJSObject)
    type_ : WorkerType;external name 'type';
    credentials : RequestCredentials;
    name : string;
  end;
  
  { --------------------------------------------------------------------
    TJSRegistrationOptions
    --------------------------------------------------------------------}
  
  TJSRegistrationOptions = class(TJSObject)
    scope : string;
    type_ : WorkerType;external name 'type';
    updateViaCache : ServiceWorkerUpdateViaCache;
  end;
  
  { --------------------------------------------------------------------
    TJSNavigationPreloadState
    --------------------------------------------------------------------}
  
  TJSNavigationPreloadState = class(TJSObject)
    enabled : Boolean;
    headerValue : string;
  end;
  
  { --------------------------------------------------------------------
    TJSClientQueryOptions
    --------------------------------------------------------------------}
  
  TJSClientQueryOptions = class(TJSObject)
    includeUncontrolled : Boolean;
    type_ : ClientType;external name 'type';
  end;
  
  { --------------------------------------------------------------------
    TJSExtendableEventInit
    --------------------------------------------------------------------}
  
  TJSExtendableEventInit = class(TJSObject)
  end;
  
  { --------------------------------------------------------------------
    TJSFetchEventInit
    --------------------------------------------------------------------}
  
  TJSFetchEventInit = class(TJSObject)
    request : TJSRequest;
    preloadResponse : TJSPromise;
    clientId : string;
    resultingClientId : string;
    replacesClientId : string;
  end;
  
  { --------------------------------------------------------------------
    TJSExtendableMessageEventInit
    --------------------------------------------------------------------}
  
  TTJSMessagePortDynArray = array of TJSMessagePort;
  TJSExtendableMessageEventInit = class(TJSObject)
    data : JSValue;
    origin : string;
    lastEventId : string;
    source : JSValue;
    ports : TTJSMessagePortDynArray;
  end;
  
  { --------------------------------------------------------------------
    TJSCacheQueryOptions
    --------------------------------------------------------------------}
  
  TJSCacheQueryOptions = class(TJSObject)
    ignoreSearch : Boolean;
    ignoreMethod : Boolean;
    ignoreVary : Boolean;
  end;
  
  { --------------------------------------------------------------------
    TJSMultiCacheQueryOptions
    --------------------------------------------------------------------}
  
  TJSMultiCacheQueryOptions = class(TJSObject)
    cacheName : string;
  end;
  
  { --------------------------------------------------------------------
    TJSMessagePort
    --------------------------------------------------------------------}
  
  TJSMessagePort = class external name 'MessagePort'  (TJSEventTarget)
  private
  public
    
      onmessage : TJSEventHandler;
      onmessageerror : TJSEventHandler;
    procedure postMessage(message : JSValue; transfer : TTJSObjectDynArray);
    procedure postMessage(message : JSValue; options : TJSPostMessageOptions); overload;
    procedure postMessage(message : JSValue); overload;
    procedure start;
    procedure close;
  end;
  
  { --------------------------------------------------------------------
    TJSAbortSignal
    --------------------------------------------------------------------}
  
  TJSAbortSignal = class external name 'AbortSignal'  (TJSEventTarget)
  private
    Faborted : Boolean; external name 'aborted';
  public
      onabort : TJSEventHandler;
    property aborted : Boolean read Faborted;
  end;
  
  { --------------------------------------------------------------------
    TJSHeaders
    --------------------------------------------------------------------}
  
  TJSHeaders = class external name 'Headers' 
  private
  public
    procedure append(name : string; value : string);
    procedure delete(name : string);
    function get(name : string): string;
    function has(name : string): Boolean;
    procedure set_(name : string; value : string); external name 'set';
  end;
  
  { --------------------------------------------------------------------
    TJSBody
    --------------------------------------------------------------------}
  
  TJSBody = class external name 'Body' 
  private
    Fbody : TJSObject; external name 'body'; 
    FbodyUsed : Boolean; external name 'bodyUsed';
  public
    function arrayBuffer: TJSPromise;
    function blob: TJSPromise;
    function formData: TJSPromise;
    function json: TJSPromise;
    function text: TJSPromise;
    property body : TJSObject read Fbody;
    property bodyUsed : Boolean read FbodyUsed;
  end;
  
  { --------------------------------------------------------------------
    TJSRequest
    --------------------------------------------------------------------}
  
  TJSRequest = class external name 'Request'  (TJSBody)
  private
    Fmethod : string; external name 'method';
    Furl : string; external name 'url';
    Fheaders : TJSHeaders; external name 'headers'; 
    Fdestination : RequestDestination; external name 'destination'; 
    Freferrer : string; external name 'referrer';
    FreferrerPolicy : ReferrerPolicy; external name 'referrerPolicy'; 
    Fmode : RequestMode; external name 'mode'; 
    Fcredentials : RequestCredentials; external name 'credentials'; 
    Fcache : RequestCache; external name 'cache'; 
    Fredirect : RequestRedirect; external name 'redirect'; 
    Fintegrity : string; external name 'integrity';
    Fkeepalive : Boolean; external name 'keepalive';
    FisReloadNavigation : Boolean; external name 'isReloadNavigation';
    FisHistoryNavigation : Boolean; external name 'isHistoryNavigation';
    Fsignal : TJSAbortSignal; external name 'signal'; 
  public
    function clone: TJSRequest;
    property method : string read Fmethod;
    property url : string read Furl;
    property headers : TJSHeaders read Fheaders;
    property destination : RequestDestination read Fdestination;
    property referrer : string read Freferrer;
    property _referrerPolicy : ReferrerPolicy read FreferrerPolicy;
    property mode : RequestMode read Fmode;
    property credentials : RequestCredentials read Fcredentials;
    property cache : RequestCache read Fcache;
    property redirect : RequestRedirect read Fredirect;
    property integrity : string read Fintegrity;
    property keepalive : Boolean read Fkeepalive;
    property isReloadNavigation : Boolean read FisReloadNavigation;
    property isHistoryNavigation : Boolean read FisHistoryNavigation;
    property signal : TJSAbortSignal read Fsignal;
  end;
  
  { --------------------------------------------------------------------
    TJSResponse
    --------------------------------------------------------------------}
  
  TJSResponse = class external name 'Response'  (TJSBody)
  private
    Ftype_ : ResponseType; external name 'type'; 
    Furl : string; external name 'url';
    Fredirected : Boolean; external name 'redirected';
    Fstatus : Cardinal; external name 'status'; 
    Fok : Boolean; external name 'ok';
    FstatusText : string; external name 'statusText';
    Fheaders : TJSHeaders; external name 'headers'; 
    Ftrailer : TJSPromise; external name 'trailer'; 
  public
    function error: TJSResponse;
    function redirect(url : string; status : Cardinal): TJSResponse; overload;
    function redirect(url : string): TJSResponse; overload;
    function clone: TJSResponse;
    property type_ : ResponseType read Ftype_;
    property url : string read Furl;
    property redirected : Boolean read Fredirected;
    property status : Cardinal read Fstatus;
    property ok : Boolean read Fok;
    property statusText : string read FstatusText;
    property headers : TJSHeaders read Fheaders;
    property trailer : TJSPromise read Ftrailer;
  end;
  
  { --------------------------------------------------------------------
    TJSWindowOrWorkerGlobalScope
    --------------------------------------------------------------------}
  
  TJSWindowOrWorkerGlobalScope = class external name 'WindowOrWorkerGlobalScope' 
  private
  public
    function fetch(input : RequestInfo; init : TJSRequestInit): TJSPromise; overload;
    function fetch(input : RequestInfo): TJSPromise; overload;
  end;
  
  { --------------------------------------------------------------------
    TJSAbstractWorker
    --------------------------------------------------------------------}
  
  TJSAbstractWorker = class external name 'AbstractWorker' 
  private
  public
      onerror : TJSEventHandler;
  end;
  
  { --------------------------------------------------------------------
    TJSWorker
    --------------------------------------------------------------------}
  
  TJSWorker = class external name 'Worker'  (TJSEventTarget)
  private
  public
      onmessage : TJSEventHandler;
      onmessageerror : TJSEventHandler;
      onerror : TJSEventHandler;
    procedure terminate;
    procedure postMessage(message : JSValue; transfer : TTJSObjectDynArray);
    procedure postMessage(message : JSValue; options : TJSPostMessageOptions); overload;
    procedure postMessage(message : JSValue); overload;
  end;
  
  { --------------------------------------------------------------------
    TJSSharedWorker
    --------------------------------------------------------------------}
  
  TJSSharedWorker = class external name 'SharedWorker'  (TJSEventTarget)
  private
    Fport : TJSMessagePort; external name 'port'; 
  public
      onerror : TJSEventHandler;
    property port : TJSMessagePort read Fport;
  end;
  
  { --------------------------------------------------------------------
    TJSServiceWorker
    --------------------------------------------------------------------}
  
  TJSServiceWorker = class external name 'ServiceWorker'  (TJSEventTarget)
  private
    FscriptURL : string; external name 'scriptURL';
    Fstate : ServiceWorkerState; external name 'state'; 
  public
      onstatechange : TJSEventHandler;
      onerror : TJSEventHandler;
    procedure postMessage(message : JSValue; transfer : TTJSObjectDynArray);
    procedure postMessage(message : JSValue; options : TJSPostMessageOptions); overload;
    procedure postMessage(message : JSValue); overload;
    property scriptURL : string read FscriptURL;
    property state : ServiceWorkerState read Fstate;
  end;
  
  { --------------------------------------------------------------------
    TJSServiceWorkerRegistration
    --------------------------------------------------------------------}
  
  TJSServiceWorkerRegistration = class external name 'ServiceWorkerRegistration'  (TJSEventTarget)
  private
    Finstalling : TJSServiceWorker; external name 'installing'; 
    Fwaiting : TJSServiceWorker; external name 'waiting'; 
    Factive : TJSServiceWorker; external name 'active'; 
    FnavigationPreload : TJSNavigationPreloadManager; external name 'navigationPreload'; 
    Fscope : string; external name 'scope';
    FupdateViaCache : ServiceWorkerUpdateViaCache; external name 'updateViaCache'; 
  public
      onupdatefound : TJSEventHandler;
    function update: TJSPromise;
    function unregister: TJSPromise;
    property installing : TJSServiceWorker read Finstalling;
    property waiting : TJSServiceWorker read Fwaiting;
    property active : TJSServiceWorker read Factive;
    property navigationPreload : TJSNavigationPreloadManager read FnavigationPreload;
    property scope : string read Fscope;
    property updateViaCache : ServiceWorkerUpdateViaCache read FupdateViaCache;
  end;
  
  { --------------------------------------------------------------------
    TJSNavigator
    --------------------------------------------------------------------}
  
  TJSNavigator = class external name 'Navigator' 
  private
    FserviceWorker : TJSServiceWorkerContainer; external name 'serviceWorker'; 
  public
    property serviceWorker : TJSServiceWorkerContainer read FserviceWorker;
  end;
  
  { --------------------------------------------------------------------
    TJSWorkerNavigator
    --------------------------------------------------------------------}
  
  TJSWorkerNavigator = class external name 'WorkerNavigator' 
  private
    FserviceWorker : TJSServiceWorkerContainer; external name 'serviceWorker'; 
  public
    property serviceWorker : TJSServiceWorkerContainer read FserviceWorker;
  end;
  
  { --------------------------------------------------------------------
    TJSServiceWorkerContainer
    --------------------------------------------------------------------}
  
  TJSServiceWorkerContainer = class external name 'ServiceWorkerContainer'  (TJSEventTarget)
  private
    Fcontroller : TJSServiceWorker; external name 'controller'; 
    Fready : TJSPromise; external name 'ready'; 
  public
      oncontrollerchange : TJSEventHandler;
      onmessage : TJSEventHandler;
      onmessageerror : TJSEventHandler;
    function register(scriptURL : string; options : TJSRegistrationOptions): TJSPromise; overload;
    function register(scriptURL : string): TJSPromise; overload;
    function getRegistration(clientURL : string): TJSPromise; overload;
    function getRegistration: TJSPromise; overload;
    function getRegistrations: TJSPromise;
    procedure startMessages;
    property controller : TJSServiceWorker read Fcontroller;
    property ready : TJSPromise read Fready;
  end;
  
  { --------------------------------------------------------------------
    TJSNavigationPreloadManager
    --------------------------------------------------------------------}
  
  TJSNavigationPreloadManager = class external name 'NavigationPreloadManager' 
  private
  public
    function enable: TJSPromise;
    function disable: TJSPromise;
    function setHeaderValue(value : string): TJSPromise;
    function getState: TJSPromise;
  end;
  
  { --------------------------------------------------------------------
    TJSServiceWorkerGlobalScope
    --------------------------------------------------------------------}
  
  TJSServiceWorkerGlobalScope = class external name 'ServiceWorkerGlobalScope'  (TJSObject)
  private
    Fclients : TJSClients; external name 'clients'; 
    Fregistration : TJSServiceWorkerRegistration; external name 'registration'; 
  public
      oninstall : TJSEventHandler;
      onactivate : TJSEventHandler;
      onfetch : TJSEventHandler;
      onmessage : TJSEventHandler;
      onmessageerror : TJSEventHandler;
    function skipWaiting: TJSPromise;
    property clients : TJSClients read Fclients;
    property registration : TJSServiceWorkerRegistration read Fregistration;
  end;
  
  { --------------------------------------------------------------------
    TJSClient
    --------------------------------------------------------------------}
  
  TJSClient = class external name 'Client' 
  private
    Furl : string; external name 'url';
    FframeType : FrameType; external name 'frameType'; 
    Fid : string; external name 'id';
    Ftype_ : ClientType; external name 'type'; 
  public
    procedure postMessage(message : JSValue; transfer : TTJSObjectDynArray);
    procedure postMessage(message : JSValue; options : TJSPostMessageOptions); overload;
    procedure postMessage(message : JSValue); overload;
    property url : string read Furl;
    property _frameType : FrameType read FframeType;
    property id : string read Fid;
    property type_ : ClientType read Ftype_;
  end;
  
  { --------------------------------------------------------------------
    TJSWindowClient
    --------------------------------------------------------------------}
  
  TstringDynArray = array of string;
  TJSWindowClient = class external name 'WindowClient'  (TJSClient)
  private
    FvisibilityState : string; external name 'visibilityState';
    Ffocused : Boolean; external name 'focused';
    FancestorOrigins : TstringDynArray; external name 'ancestorOrigins';
  public
    function focus: TJSPromise;
    function navigate(url : string): TJSPromise;
    property visibilityState : string read FvisibilityState;
    property focused : Boolean read Ffocused;
    property ancestorOrigins : TstringDynArray read FancestorOrigins;
  end;
  
  { --------------------------------------------------------------------
    TJSClients
    --------------------------------------------------------------------}
  
  TJSClients = class external name 'Clients' 
  private
  public
    function get(id : string): TJSPromise;
    function matchAll(options : TJSClientQueryOptions): TJSPromise; overload;
    function matchAll: TJSPromise; overload;
    function openWindow(url : string): TJSPromise;
    function claim: TJSPromise;
  end;
  
  { --------------------------------------------------------------------
    TJSExtendableEvent
    --------------------------------------------------------------------}
  
  TJSExtendableEvent = class external name 'ExtendableEvent'  (TJSEvent)
  private
  public
    procedure waitUntil(f : TJSPromise);
  end;
  
  { --------------------------------------------------------------------
    TJSFetchEvent
    --------------------------------------------------------------------}
  
  TJSFetchEvent = class external name 'FetchEvent'  (TJSExtendableEvent)
  private
    Frequest : TJSRequest; external name 'request'; 
    FpreloadResponse : TJSPromise; external name 'preloadResponse'; 
    FclientId : string; external name 'clientId';
    FresultingClientId : string; external name 'resultingClientId';
    FreplacesClientId : string; external name 'replacesClientId';
  public
    procedure respondWith(r : TJSPromise);
    property request : TJSRequest read Frequest;
    property preloadResponse : TJSPromise read FpreloadResponse;
    property clientId : string read FclientId;
    property resultingClientId : string read FresultingClientId;
    property replacesClientId : string read FreplacesClientId;
  end;
  
  { --------------------------------------------------------------------
    TJSExtendableMessageEvent
    --------------------------------------------------------------------}
  
  TJSExtendableMessageEvent = class external name 'ExtendableMessageEvent'  (TJSExtendableEvent)
  private
    Fdata : JSValue; external name 'data'; 
    Forigin : string; external name 'origin';
    FlastEventId : string; external name 'lastEventId';
    Fsource : JSValue; external name 'source'; 
    Fports : TTJSMessagePortDynArray; external name 'ports'; 
  public
    property data : JSValue read Fdata;
    property origin : string read Forigin;
    property lastEventId : string read FlastEventId;
    property source : JSValue read Fsource;
    property ports : TTJSMessagePortDynArray read Fports;
  end;
  
  
  { --------------------------------------------------------------------
    TJSCache
    --------------------------------------------------------------------}
  
  TRequestInfoDynArray = array of RequestInfo;
  
  TJSCache = class external name 'Cache' 
  private
  public
    function match(request : RequestInfo; options : TJSCacheQueryOptions): TJSPromise; overload;
    function match(request : RequestInfo): TJSPromise; overload;
    function matchAll(request : RequestInfo; options : TJSCacheQueryOptions): TJSPromise; overload;
    function matchAll: TJSPromise; overload;
    function matchAll(request : RequestInfo): TJSPromise; overload;
    function add(request : RequestInfo): TJSPromise;
    function addAll(requests : TRequestInfoDynArray): TJSPromise;
    function put(request : RequestInfo; response : TJSResponse): TJSPromise;
    function delete(request : RequestInfo; options : TJSCacheQueryOptions): TJSPromise; overload;
    function delete(request : RequestInfo): TJSPromise; overload;
    function keys(request : RequestInfo; options : TJSCacheQueryOptions): TJSPromise; overload;
    function keys: TJSPromise; overload;
    function keys(request : RequestInfo): TJSPromise; overload;
  end;
  
  { --------------------------------------------------------------------
    TJSCacheStorage
    --------------------------------------------------------------------}
  
  TJSCacheStorage = class external name 'CacheStorage' 
  private
  public
    function match(request : RequestInfo; options : TJSMultiCacheQueryOptions): TJSPromise; overload;
    function match(request : RequestInfo): TJSPromise; overload;
    function has(cacheName : string): TJSPromise;
    function open(cacheName : string): TJSPromise;
    function delete(cacheName : string): TJSPromise;
    function keys: TJSPromise;
  end;

implementation


end.
